import * as types from "./ActionTypes";
import * as presClubApi from "../../apis/presclub/PresClubApi";
import { addActiveApiCall } from "./ActiveApiActions";

export function loadPresClubRevenueSuccess(revDetails) {
  return { type: types.LOAD_PRES_CLUB_REVENUE_SUCCESS, revDetails };
}

export function loadPresClubRevenueAdminSuccess(revDetails) {
  return { type: types.LOAD_PRES_CLUB_REVENUE_ADMIN_SUCCESS, revDetails };
}

export function loadPresClubUtilizationSuccess(utilDetails) {
    return { type: types.LOAD_PRES_CLUB_UTILIZATION_SUCCESS, utilDetails };
}

export function loadPresClubUtilizationAdminSuccess(utilDetails) {
  return { type: types.LOAD_PRES_CLUB_UTILIZATION_ADMIN_SUCCESS, utilDetails };
}

export function loadPresClubRevenueAdmin() {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.LOAD_PRES_CLUB_REVENUE_ADMIN_SUCCESS));
    return presClubApi
      .getRevenueLeadersAdmin()
      .then(revDetails => {
        dispatch(loadPresClubRevenueAdminSuccess(revDetails));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function loadPresClubRevenue(userId = null) {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.LOAD_PRES_CLUB_REVENUE_SUCCESS));
    return presClubApi
      .getRevenueLeaders(userId)
      .then(revDetails => {
        dispatch(loadPresClubRevenueSuccess(revDetails));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function loadPresClubUtilization(userId = null) {
    return function(dispatch) {
        dispatch(addActiveApiCall(types.LOAD_PRES_CLUB_UTILIZATION_SUCCESS));
        return presClubApi
            .getUtilizationLeaders(userId)
            .then(utilDetails => {
                dispatch(loadPresClubUtilizationSuccess(utilDetails));
            })
            .catch(error => {
                throw error;
            });
    }
}

export function loadPresClubUtilizationAdmin() {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.LOAD_PRES_CLUB_UTILIZATION_ADMIN_SUCCESS));
    return presClubApi
        .getUtilizationLeadersAdmin()
        .then(utilDetails => {
            dispatch(loadPresClubUtilizationAdminSuccess(utilDetails));
        })
        .catch(error => {
            throw error;
        });
  }
}
